import script from "./AnalyticPermitionModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalyticPermitionModal.vue?vue&type=script&setup=true&lang=ts"

import "./AnalyticPermitionModal.vue?vue&type=style&index=0&id=1179901d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1179901d"]])

export default __exports__